import React from 'react';
import { tasks } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const TaskCategories = () => {
  return (
    <section className="py-16 bg-gray-100 border-b border-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-black text-slate-900 uppercase tracking-tight">Shop By Yard Task</h2>
          <div className="h-1 w-20 bg-lime-400 mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-8">
          {tasks.map(task => (
            <div key={task.id} className="bg-white border-2 border-slate-200 hover:border-lime-400 p-6 flex flex-col items-center justify-center text-center cursor-pointer transition-all group hover:shadow-lg rounded-sm">
              <div className="bg-slate-100 p-4 rounded-full group-hover:bg-lime-100 transition-colors mb-4">
                <SafeIcon name={task.icon.replace('Fi', '')} className="text-3xl text-slate-800 group-hover:text-green-700" />
              </div>
              <h3 className="font-bold text-slate-800 uppercase text-sm tracking-wide">{task.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TaskCategories;